import { Box } from '@mui/material';
import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { StackBarChartProps } from '../types';

export const StackBarChart = ({ testsBySubjectAndLocation } : StackBarChartProps) => {
  const categories: { [subject: string]: boolean } = {};
  const seriesVinaData: number[] = [];
  const seriesSantiagoData: number[] = [];
  const seriesNoSedeData: number[] = [];
  const seriesOnlineData: number[] = [];
  if (Object.keys(testsBySubjectAndLocation).length) {
    Object.keys(testsBySubjectAndLocation).forEach((key) => {
      const data = testsBySubjectAndLocation[key];
      if (data) {
        categories[key] = true;
        seriesVinaData.push(data.vina);
        seriesSantiagoData.push(data.santiago);
        seriesNoSedeData.push(data.inPersonNoSede);
        seriesOnlineData.push(data.online);
      }
    });
  }

  const stackedBarChartOptions = {
    chart: {
      type: 'column',
    },
    title: {
      text: 'Ensayos rendidos',
      align: 'left',
    },
    xAxis: {
      categories: Object.keys(categories),
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Número ensayos',
      },
      stackLabels: {
        enabled: true,
      },
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: [
      {
        name: 'Presencial - Viña',
        data: seriesVinaData,
        stack: 'presencial',
      },
      {
        name: 'Presencial - Santiago',
        data: seriesSantiagoData,
        stack: 'presencial',
      },
      ...(seriesNoSedeData.some((value) => value > 0) ? [{
        name: 'Presencial sin sede',
        data: seriesNoSedeData,
        stack: 'presencial',
      }] : []),
      {
        name: 'Online',
        data: seriesOnlineData,
        stack: 'online',
      },
    ],
  };

  return (
    <Box style={{ width: '33%' }}>
    <HighchartsReact highcharts={Highcharts} options={stackedBarChartOptions} />
  </Box>
  );
};
